export default __webpack_public_path__ + "static/media/primary.21e261091c65fa6e087bff6cc8df6fa5.svg";